/**
 * @file   src\components\CWOLayout.tsx
 * @brief  This component used as a CWOLayout for the content which can be replaced.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { Outlet, useState, React } from '../utils/thirdpartyComponents';
import CWOHeader from './CWOHeader';
import CWFooter from './CWFooter';
import { AppContextType, dataInterface } from '../interfaces/generalInterface';


const CWOLayout = () => {

  //State to handle heading and back button for all headers depending on page
  const [data, setData] = useState<dataInterface>({ heading: "", url: "", showBackButton: true, showMainMenu: true, activeLink: "" });

  // This function will be passed to children to update the state
  const updateData = (newValue: dataInterface) => {
    setData(newValue);
  };

  return (
    <>
      <div className="cw-main-wrap">
        <CWOHeader data={data} />
        <div className="cw-content-wrap"><Outlet context={{ data, updateData } as AppContextType} /></div>
      </div>
      <CWFooter />
    </>
  );
};

export default CWOLayout;
